export default __webpack_public_path__ + "static/media/coding.895d645c.svg";